import { MediaSubscription } from '../../Shared/models/media-subscription.model';
import { BackfillStatusApiEnum } from '../../../api/mediaSubscriptions/enums/backfill-status.api.enum';
import { BackfillApi } from '../../../api/mediaSubscriptions/models/backfill.api.model';

export class MediaSubscriptionBackfill {
    status: BackfillStatusApiEnum;
    createdDate: Date;
    fromDate: Date;
    toDate: Date;
    mentionCount: number;
    customSub?: MediaSubscription;
    queryFields?: {
        handles?: string[];
        mediaTypes?: string[];
        and?: string[];
        not?: string[];
        or?: string[];
    };

    constructor(apiModel: BackfillApi) {
        if (apiModel) {
            this.status = apiModel.status;
            this.createdDate = new Date(apiModel.createdDate);
            this.fromDate = new Date(apiModel.backfillBeginDate);
            this.toDate = new Date(apiModel.backfillEndDate);
            this.mentionCount = apiModel.numberOfMentionsCollected;
            if (apiModel.customSub) {
                this.customSub = new MediaSubscription(apiModel.customSub);
            }
            if (apiModel.queryFields) {
                this.queryFields = apiModel.queryFields;
                if (apiModel.queryFields.mustTerms) {
                    this.queryFields.and = apiModel.queryFields.mustTerms;
                }
                if (apiModel.queryFields.shouldTerms) {
                    this.queryFields.or = apiModel.queryFields.shouldTerms;
                }
                if (apiModel.queryFields.mustNotTerms) {
                    this.queryFields.not = apiModel.queryFields.mustNotTerms;
                }
            }
        }
    }
}
